import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import SdgScoreClob, { ISdgData } from './_sdgScoreClob';
import Link from 'components/Link';
import LearnMoreModal from 'kosmos/dialogs/LearnMoreModal';
import { useTranslation } from 'react-i18next';

const PREFIX = '_esgLegand';

const classes = {
  legandContainer: `${PREFIX}-legandContainer`,
  legands: `${PREFIX}-legands`,
  iconTitle: `${PREFIX}-iconTitle`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  marginBottom: theme.spacing(4),
  width: '100%',
  [`& .${classes.iconTitle}`]: {},
  [`& .${classes.legandContainer}`]: {
    padding: 0,
    paddingLeft: 30,
    backgroundColor: '#3544d0',
  },
  [`& .${classes.legands}`]: {
    padding: theme.spacing(2),
    backgroundColor: 'white',
    border: '2px solid #808080',
    borderLeftWidth: 0,
  },
}));

interface IProps {
  title: string;
  legands: ISdgData[];
  learnMoreTabId?: string;
}

export default function EsgLegand(props: IProps): JSX.Element {
  const { title, legands, learnMoreTabId } = props;
  const [openLearnMoreTabId, setOpenLearnMoreTabId] = useState('');
  const { t } = useTranslation('default');

  const renderLegand = (legand: ISdgData, index: number) => {
    return <SdgScoreClob key={index} {...legand} />;
  };

  return (
    <Root>
      <div>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'regular' }}>
          {title}
          {learnMoreTabId && (
            <Link onClick={() => setOpenLearnMoreTabId(learnMoreTabId)} text={t('learn-more')} />
          )}
        </Typography>
      </div>
      <LearnMoreModal
        openLearnMoreTabId={openLearnMoreTabId}
        onClose={() => setOpenLearnMoreTabId('')}
      />
      {legands.length > 0 && (
        <div className={classes.legandContainer}>
          <div className={classes.legands}>
            <Stack direction="column" spacing={1}>
              {legands.map(renderLegand)}
            </Stack>
          </div>
        </div>
      )}
    </Root>
  );
}
